export const AUTH_REQUEST = 'AUTH_REQUEST';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_REQUEST_REFRESH = 'AUTH_REQUEST_REFRESH';
export const AUTH_MAGIC_LINK = 'AUTH_MAGIC_LINK';
export const AUTH_CODE = 'AUTH_CODE';
export const AUTH_CHECK_CODE = 'AUTH_CHECK_CODE';

export const AUTH_ONBOARDING = 'AUTH_ONBOARDING';
